import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-order-column',
  templateUrl: './order-column.component.html',
  styleUrls: ['./order-column.component.scss'],
})
export class OrderColumnComponent {
  @Input() data: unknown;
}
